export const environment = {
  backendURL: "https://api.staging.screenwatchsystem.com",
  useXDebugInterceptor: false,
  refreshTime: 600_000,
  sso_client_id: "9102ecb9-68e2-4aba-84b4-b3b11d267618",
  sso_scope: "openid swsprofile",
  sso_domain: "https://mytestlogin.luxottica.com/"
};
